import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Button } from 'shared/components';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  isDisabled: PropTypes.bool.isRequired,
  handleCancelClick: PropTypes.func.isRequired,
  testId: PropTypes.string,
};

const defaultProps = {
  testId: 'close-button',
};

const CloseButton = ({
  intl,
  isDisabled,
  handleCancelClick,
  testId,
}) =>
  (
    <Button
      testId={ testId }
      label={ intl.formatMessage({ id: 'const.button.close', defaultMessage: '** Close' }) }
      labelColor="blackMedium"
      buttonType="naked"
      disabled={ isDisabled }
      onClick={ handleCancelClick }
    />
  );

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;

export default injectIntl(CloseButton);
